// extracted by mini-css-extract-plugin
export default {"header":"Earning_header__-g6WM"};